import { createSlice } from '@reduxjs/toolkit';
import { settingResource } from '../../resources/Setting.resource';
var initialState = {
    data: []
};
export var SettingsReducer = createSlice({
    name: 'settings',
    initialState: initialState,
    reducers: {
        setSettings: function setSettings(state, payloadAction) {
            state.data = payloadAction.payload.map(function (item) {
                return settingResource(item);
            });
        },
        updateSetting: function updateSetting(state, payloadAction) {
            var setting = settingResource(payloadAction.payload);
            state.data = state.data.map(function (item) {
                return item.id === payloadAction.payload.id ? setting : item;
            });
        }
    }
});
var _SettingsReducer$acti = SettingsReducer.actions, setSettings = _SettingsReducer$acti.setSettings, updateSetting = _SettingsReducer$acti.updateSetting;
export { setSettings, updateSetting };
export default SettingsReducer.reducer;
